import { render, staticRenderFns } from "./FiltersMainCategories.vue?vue&type=template&id=3cce74c9&"
import script from "./FiltersMainCategories.vue?vue&type=script&lang=js&"
export * from "./FiltersMainCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/toastgroup.no/toastgroup.no/wp-content/themes/toastgroup/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cce74c9')) {
      api.createRecord('3cce74c9', component.options)
    } else {
      api.reload('3cce74c9', component.options)
    }
    module.hot.accept("./FiltersMainCategories.vue?vue&type=template&id=3cce74c9&", function () {
      api.rerender('3cce74c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/front/js/compontents/filters/FiltersMainCategories.vue"
export default component.exports